import { Button, Col, Image, Layout, Row } from "antd";
import { motion } from "framer-motion";
import React from "react";
import "./Style.css";
import IMG1 from "../../assets/home/1.jpg";
import IMG2 from "../../assets/home/1.svg";
import IMGS1 from "../../assets/home/s1.jpg";
import IMGS2 from "../../assets/home/s2.jpg";
import IMGS3 from "../../assets/home/s3.jpg";
import IMGS4 from "../../assets/home/s4.jpg";
import IMGS5 from "../../assets/home/s5.jpg";

const textContent = [
  "Since childhood, I have shared a deep bond with my grandfather over chess, each move opening the door to his stories about agriculture - his lifelong passion and expertise. Through these chess matches, I gradually absorbed his love and respect for farming. While my friends dreamed of becoming superheroes or artists, I harbored a simple dream of becoming a farmer.",
  "However, I don’t want to follow the traditional path, where farmers “work with their faces to the soil and backs to the sky.”- toiling endlessly on the field. Ranked among the top three rice exporters in the world, Vietnam still sees its farmers facing challenging lives, with incomes that don’t reflect the labor they invest. In my hometown, agriculture still relies on basic farming models, which presents both a challenge and a motivation for me to turn difficulties into opportunities.",
  "I am constantly driven by a desire to contribute to a technological revolution in agriculture, hoping to improve the livelihoods and enhance the autonomy of farmers—those who play a vital role in sustaining the food supply for Vietnamese society.",
];

const sectionPages = [
  {
    img: IMGS1,
    title: "AI & Agriculture",
    link: "/ai",
  },
  {
    img: IMGS2,
    title: "Achievements",
    link: "/achievements",
  },
  {
    img: IMGS3,
    title: "Music",
    link: "/music",
  },
  {
    img: IMGS4,
    title: "Double Cannons",
    link: "/double",
  },
  {
    img: IMGS5,
    title: "Striving For A Change",
    link: "/striving",
  },
];

const { Content } = Layout;
const HomePage = () => {
  return (
    <>
      <Layout
        style={{
          backgroundColor: "#fff",
        }}
      >
        <Content>
          <Image
            className="w-full h-full"
            src={IMG2}
            alt="Image 2"
            preview={false}
          />
        </Content>
        <Content
          style={{
            padding: "40px 20px",
            maxWidth: "1400px",
            margin: "0 auto",
            backgroundColor: "#fff",
          }}
        >
          <Row gutter={[30, 30]} align="middle">
            <Col xs={24} sm={24} md={24} lg={12}>
              <motion.div
                initial={{ opacity: 0, x: -100 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
              >
                <Image
                  className="w-full h-full"
                  src={IMG1}
                  alt="Image 1"
                  preview={false}
                />
              </motion.div>{" "}
            </Col>
            <Col xs={24} sm={24} md={24} lg={12}>
              <div className="text-section">ABOUT ME</div>
              <div>
                {textContent.map((paragraph, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: index * 0.5, duration: 0.8 }}
                  >
                    <p
                      className="text-color-2"
                      style={{
                        display: "block",
                        marginBottom: "16px",
                        fontSize: "16px",
                        lineHeight: "1.8",
                        textAlign: "justify",
                      }}
                    >
                      {paragraph}
                    </p>
                  </motion.div>
                ))}
              </div>
              <div style={{ textAlign: "right" }}>
                <Button
                  type="primary"
                  shape="round"
                  size="large"
                  className="button-background-pri"
                  href="https://drive.google.com/file/d/1BI_K_Jf6yxnUlkwoPz5MhOstSdR3D5iG/view"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  My Resume
                </Button>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
      <Layout
        style={{
          backgroundColor: "#F8F7F0",
        }}
      >
        <Content
          style={{
            padding: "80px 10px",
            maxWidth: "1400px",
            margin: "0 auto",
          }}
        >
          <Row gutter={[30, 30]}>
            <Col
              span={24}
              style={{ paddingTop: 0, paddingBottom: 80, textAlign: "center" }}
            >
              <div className="text-section text-center">
                Get to know me better!
              </div>
            </Col>
          </Row>

          <Row gutter={[30, 30]}>
            <div className="home-section-grid">
              {sectionPages.map((el, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  className="home-section-grid-item"
                >
                  <Image
                    className="home-section-grid-item-img"
                    src={el.img}
                    alt={el.title}
                    preview={false}
                  />
                  <Button
                    type="primary"
                    size="large"
                    className="home-section-grid-item-btn"
                    onClick={() => (window.location.href = el.link)} // Navigate to the link on button click
                  >
                    {el.title}
                  </Button>
                </motion.div>
              ))}
            </div>
          </Row>
        </Content>
      </Layout>
    </>
  );
};

export default HomePage;
